import { diff_in_days } from "../utils/dates/diff_in_days";
import { Venue, VenueCategory } from "../../types/venue";
import { FeatureFilters } from "../../types/search";
import { getNewArrivals } from "../utils/VenuesUtilities";

export const getVisibleVenues = (allVenues: Venue[],
                                 allCategories: VenueCategory[],
                                 selectedCategories: VenueCategory[],
                                 selectedRootCategory: VenueCategory | null | undefined,
                                 features: FeatureFilters) => {
  const selectedCategoriesIds = selectedCategories.map((category) => category.id)

  let venues = allVenues

  // Filter venues that does not accept discount codes
  if (features.discount) {
    venues = venues.filter((venue) => venue.accepts_discount_codes === true)
  }

  // Filter venues that does not accept credit cards
  if (features.creditCard) {
    venues = venues.filter((venue) => venue.accepts_stripe === true)
  }

  // Filter venues that does not accept cash
  if (features.cash) {
    venues = venues.filter((venue) => venue.accepts_cash === true)
  }

  // Filter venues that are new
  if (features.new) {
    venues = getNewArrivals(venues)
  }

  // Filter venues that have promotions
  if (features.promotion) {
    venues = venues.filter((venue) => !!venue.promotion)
  }

  // Filter by selected root category
  if (selectedRootCategory) {
    const selectedRootCategoryId = selectedRootCategory.id
    const subRootCategoryIds = allCategories
      .filter((category) => category.parent_id === selectedRootCategoryId)
      .map(category => category.id)

    venues = venues.filter((venue) => {
      return venue.venue_category_ids.some((id) => {
        return subRootCategoryIds.includes(id)
      })
    })

    // Filter by selected categories
    if (selectedCategoriesIds.length > 0) {
      venues = venues.filter((venue) => {
        return venue.venue_category_ids.some((category_id) => selectedCategoriesIds.indexOf(category_id) !== -1)
      })
    }
  }

  return venues
}
